import {SetDefaultProductPayloadDto} from '@features/product/application/use_cases/set-default-product/dto/set-default-product.payload.dto';
import {SetDefaultProductResponseDto} from '@features/product/application/use_cases/set-default-product/dto/set-default-product.response.dto';
import {SetDefaultProductHttpPayloadDto} from '@features/product/infrastructure/http/set-default-product/set-default-product.http.payload.dto';
import {SetDefaultProductHttpResponseDto} from '@features/product/infrastructure/http/set-default-product/set-default-product.http.response.dto';

export class SetDefaultProductHttpMapper {

  static toResponse(data: SetDefaultProductHttpResponseDto): SetDefaultProductResponseDto {
    return {};
  }

  static toInfra(data: SetDefaultProductPayloadDto): SetDefaultProductHttpPayloadDto {
    return {};
  }

}
